export default "__VITE_ASSET__DRPUw6dE__"